import React from "react";
import Chart from "react-apexcharts";
import { Card, CardBody } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const IncidentResponseGraph = () => {
  const series = [
    {
      name: "Incident Count",
      type: "line",
      data: [10, 12, 14, 11, 13, 15, 12],
    },
    {
      name: "Avg. Response Time (min)",
      type: "line",
      data: [28, 24, 30, 26, 28, 22, 20],
    },
  ];

  const options = {
    chart: {
      type: "line",
      toolbar: { show: false },
      background: "transparent",
      zoom: { enabled: false },
    },
    stroke: {
      width: [3, 3],
      curve: "smooth",
    },
    colors: ["#FF5B00", "#FFFD98"],
    dataLabels: { enabled: false },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      labels: { colors: "#6c757d" },
      markers: { width: 10, height: 10, radius: 2 },
    },
    xaxis: {
      categories: [
        "Jul 20", "Jul 21", "Jul 22", "Jul 23", "Jul 24", "Jul 25", "Jul 26",
      ],
      labels: { style: { colors: "#6c757d", fontSize: "11px" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: [
      {
        min: 0,
        max: 16,
        tickAmount: 4,
        labels: { style: { colors: "#6c757d", fontSize: "11px" } },
      },
      {
        opposite: true,
        min: 0,
        max: 32,
        tickAmount: 4,
        labels: { style: { colors: "#6c757d", fontSize: "11px" } },
      },
    ],
    grid: { borderColor: "#e9ecef", strokeDashArray: 3 },
    tooltip: { theme: "auto", shared: true, intersect: false },
  };

  return (
    <Card
      className="border-0 shadow-sm mt-4"
      style={cardShell}
    >
      <CardBody>
        <h5 className="fw-bold mb-3" style={{ color: "var(--bs-body-color)" , backgroundColor:"var(--bs-secondary-bg)"}}>
          Incident count vs response time
        </h5>
        <div style={{ width: "100%", height: "300px" }}>
          <Chart options={options} series={series} type="line" height="300" />
        </div>
      </CardBody>
    </Card>
  );
};

export default IncidentResponseGraph;
